module.exports = __webpack_public_path__ + "static/media/level_07-08.0a69f836.jpg";